/*
 *
 * Application
 *
 */

import { useIntl } from 'react-intl';

import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';

import DrawerButton from '~/containers/DrawerButton';

import messages from './messages';
import styles from './styles.module.css';
import { Outlet } from '@tanstack/react-router';

export const Application = () => {
  const intl = useIntl();
  return (
    <div className={styles['application-wrapper']}>
      <div>
        <AppBar data-test="title" position="static">
          <Toolbar>
            <DrawerButton />
            <Typography variant="h6" className={styles.title} sx={{ ml: 2 }}>
              {intl.formatMessage(messages.header)}
            </Typography>
          </Toolbar>
        </AppBar>
      </div>
      <div className={styles.content}>
        <Outlet />
      </div>
    </div>
  );
};

export default Application;
